import { useContext, useEffect, useRef, useState } from 'react'
import ApiContext from 'src/provider/API/call-service'
import { CustomContainer } from 'src/style'
import { Filter, Portal, ServerSideTable } from 'src/component'
import { serviceProviderReportData, serviceProviderReportColumns } from 'src/utils/table-layout'
import helpers from 'src/utils/helpers'

export const ServiceProviderReport = () => {
    const {API, downloadReport} = useContext(ApiContext)
    const [reportData, setReportData] = useState<any>(null)
    const [report, setReport] = useState<any>(null)
    const [resetPagination, setResetPagination] = useState<boolean>(false)
    const [view, setView] = useState<string>('')
    
    const filterDataRef = useRef({})

    useEffect(() => {
        filterDataRef.current = {}
        handleFetchReport()
    }, [])

    async function handleFetchReport (pageNumber = 1, pageSize = 10, isDownload = false) {
        const response = {data: serviceProviderReportData, total: 4}

        if (response) {
            if (isDownload) {
                return downloadReport(response, 'CATEGORIES_REPORT')
            }

            response.data = helpers.addSerialNumberToItems(response?.data, {pageNumber, pageSize})

            setReportData(response)
            setReport(response.data)
        }
    }

    function handleClear () {
        filterDataRef.current = {}
        handleFetchReport()
        setResetPagination(!resetPagination)
    }

    return (
        <>
            <CustomContainer>
                <ServerSideTable
                    tableData={report}
                    tableColumns={serviceProviderReportColumns} 
                    dataFetchMethod={handleFetchReport}
                    totalRows={reportData?.total}
                    customStyle
                    shouldResetPagination={resetPagination}
                    canFilter={() => setView('filter')}
                    canClear={handleClear}
                    downloadAction={() => handleFetchReport(1, 10, true)}
                />
            </CustomContainer>
            { view === 'filter' &&
                <Portal>
                    <Filter
                        type='service-provider-report'
                        onApplyFilter={handleFetchReport}
                        setFilterData={(data: any) => {filterDataRef.current = data}}
                        close={() => setView('')}
                        top='35'
                    />
                </Portal>
            }
        </>
    )
}